<script>
	export default {
		onLaunch: function() {
			console.log('App Launch')
		},
		onShow: function() {
			console.log('App Show')
		},
		onHide: function() {
			console.log('App Hide')
		}
	}
</script>

<style lang="scss">
	/* #ifndef APP-NVUE */
		/*每个页面公共css */
		html, body, div, span, applet, object, iframe,
	h1, h2, h3, h4, h5, h6, p, blockquote, pre,
	a, abbr, acronym, address, big, cite, code,
	del, dfn, em, img, ins, kbd, q, s, samp,
	small, strike, strong, sub, sup, tt, var,
	b, u, i, center,
	dl, dt, dd, ol, ul, li,
	fieldset, form, label, legend,
	table, caption, tbody, tfoot, thead, tr, th, td,
	article, aside, canvas, details, embed, 
	figure, figcaption, footer, header, hgroup, 
	menu, nav, output, ruby, section, summary,
	time, mark, audio, video {
		margin: 0;
		padding: 0;
		border: 0;
		vertical-align: baseline;
	}
	/* HTML5 display-role reset for older browsers */
	article, aside, details, figcaption, figure, 
	footer, header, hgroup, menu, nav, section {
		display: block;
	}
	body {
		line-height: 1;
		height: 100%;
		background: #ffffff;
		font-size: 28upx;
		font-weight: 400;
		font-family: PingFangSC-Regular, PingFang SC;
	}
	.both{
		clear:both
	}
	ol, ul {
		list-style: none;
	}
	blockquote, q {
		quotes: none;
	}
	blockquote:before, blockquote:after,
	q:before, q:after {
		content: '';
		content: none;
	}
	table {
		border-collapse: collapse;
		border-spacing: 0;
	}
	.list-end {
		text-align: center;
		margin: 40upx 0;
	}
	
	.font-11 {
		font-size: 22upx;
	}
	
	.font-12 {
		font-size: 24upx;
	}
	
	.font-13 {
		font-size: 26upx;
	}
	
	.font-14 {
		font-size: 28upx;
	}
	
	.font-15 {
		font-size: 30upx;
	}
	
	.font-16 {
		font-size: 32upx;
	}
	
	.font-17 {
		font-size: 34rpx;
	}
	
	.font-weight-500 {
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
	}
	
	.font-weight-600 {
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
	}
	
	.color-ccc {
		color: #ccc;
	}
	
	.color-fff {
		color: #fff;
	}
	
	.color-333 {
		color: #333;
	}
	
	.color-555 {
		color: #555;
	}
	
	.color-666 {
		color: #666;
	}
	
	.color-888 {
		color: #888;
	}
	
	
	.color-999 {
		color: #999;
	}
	/* #endif */
	
</style>
